import React, { ReactElement } from 'react';
import './boxListItemComponent.scss';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Link } from 'idsk-react-components';
import BoxListItemType from '../BoxListItemType';

interface Props {
  item: BoxListItemType;
  className?: string;
}

const BoxListItemComponent = ({
  item,
  className,
}: Props): ReactElement => {
  const classes: string = classNames('box-list-item-component-wrapper', className);
  return (
    <div className={classes}>
      <div className="box-list-item-component">
        {item.iconPath && (
          <img
            className="image"
            src={item.iconPath}
            alt={item.name}
          />
        )}
        <Link
          className="link"
          to={item.to}
        >
          {item.name}
        </Link>
        <FontAwesomeIcon
          icon={faChevronRight}
          size="xs"
        />
      </div>
      <div className="description">{item.description}</div>
    </div>
  );
};
export default BoxListItemComponent;
